import { AxiosResponse } from 'axios';

export const getFileNameFromResponse = <T>(response: AxiosResponse<BlobPart, T>): string => {
    const header = response.headers['content-disposition'];
    const filenameRegex = /filename\*?=(?:UTF-8''|")?([^;\r\n"]+)/i;
    const match = header.match(filenameRegex);
    const filenamePart = match && match[1] ? decodeURIComponent(match[1]) : '';
    return filenamePart;
};
